export const muiTooltip = {
  defaultProps: {
    arrow: true,
  },
};
